import React, { useEffect } from 'react'
import styles from './styles.module.scss'
import Button from '../../components/Button'
import { IoMdCreate } from 'react-icons/io'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { deleteStudent, getCurrent, getStudents} from '../../actions/profotbor'
import { AddEditModal, PeoplesModal } from './Components'
import Loader from '../../components/Loader'
import moment from 'moment'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'


export default function Current () {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { id } = useParams()

  const { current: data, loading } = useSelector(state => state.profotbor)

  const [modal, setModal] = useState(false)

  useEffect(() => {
    dispatch(getCurrent(id));
    dispatch(getStudents(id));
  }, [])


  const goBackHandler = () => navigate('/profotbor')

  const deleteClickHandler = (memberId) => (e) => {
    e.stopPropagation()
    dispatch(deleteStudent(data.id, memberId));
  }

  const renderRow = (student) => {
    const { fio, birthday, groupname, pm_id, spetsialnost} = student
    return (
      <tr>
        <td>{fio}</td>
        <td>{moment(birthday).format('DD.MM.YYYY')}</td>
        <td>{groupname}</td>
        <td>{spetsialnost}</td>
        <td onClick={deleteClickHandler(pm_id)}><i className={styles.trash} ><BiTrash /></i></td>
      </tr>
    )
  }

  if (loading || !data) return <Loader/>;

  return (
    <div className={styles.currentWrapper}>
      <h1>
        Профотбор
        <IoMdCreate onClick={() => setModal(true)}/>
      </h1>

      <section>
        <p>Название:</p>
        <span>{data.name}</span>
      </section>

      <section>
        <p>Вуз:</p>
        <span>{data.vuz}</span>
      </section>

      <section>
        <p>Дата:</p>
        <span>{data.dt}</span>
      </section>

      <section>
        <p>Звание:</p>
        <span>{data.zvanie}</span>
      </section>

      <section>
        <p>Должность:</p>
        <span>{data.doljnost}</span>
      </section>

      <section>
        <p>ФИО:</p>
        <span>{data.fio}</span>
      </section>

      <section>
        <p>Форма проведения:</p>
        <span>{data.forma_provedeniya}</span>
      </section>

      <section>
        <p>Участники:</p>
        {data.members?.length 
          ? <Table>
              <thead>
                <tr>
                  <th>ФИО</th>
                  <th>Дата рождения</th>
                  <th>Класс</th>
                  <th>Специальность</th>
                </tr>
              </thead>
              <tbody>
                {data.members.map(renderRow)}
              </tbody>
            </Table>
          : <span>Нет участников</span>
        }
        <PeoplesModal data={data.members}/>
      </section>


      <Button style={{ padding: '.5rem 1.5rem' }} onClick={goBackHandler}>
        Выйти
      </Button>
      <AddEditModal
        data={data}
        addMode={false}
        open={modal}
        closeModal={() => setModal(false)}
      />
    </div>
  )
}
